import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { getCategoryUser } from "@/js/user/user";
import { getSymbolCurrency as _getSymbolCurrency } from "@/js/currency/currencies.js";
import { listWineRangeAccessibility, WineRangeAccessibilityEnum } from "@/js/lists.ts";
export default {
  name: "WineRangeAccessibiliity",
  props: {
    loggedUserData: Object,
    wine: Object,
    currency: {
      type: String,
      default: "EUR"
    }
  },
  data: function data() {
    return {
      categoryUser: null,
      amount: 0,
      maxValue: 50000,
      tickLabels: {
        0: "0",
        15000: "Connoisseur"
      },
      listWineRangeAccessibility: listWineRangeAccessibility
    };
  },
  created: function created() {
    var _this = this;
    this.categoryUser = getCategoryUser();
    this.$EventBus.$on("refresh_category_user", function (value) {
      _this.categoryUser = value;
    });
  },
  methods: {
    getMissingAmounts: function getMissingAmounts() {
      var missingAmounts = [];
      if (this.wine.rangeAccessibility && this.wine.rangeAccessibility !== WineRangeAccessibilityEnum.CORE_ITEM) {
        var missingAmount = 0;
        if (this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated <= listWineRangeAccessibility.find(function (x) {
          return x.id == WineRangeAccessibilityEnum.CORE_ITEM;
        }).maxAmount) {
          this.amount = this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated;
          this.maxValue = listWineRangeAccessibility.find(function (x) {
            return x.id == WineRangeAccessibilityEnum.PREMIUM;
          }).minAmount;
          missingAmount = listWineRangeAccessibility.find(function (x) {
            return x.id == WineRangeAccessibilityEnum.PREMIUM;
          }).minAmount - (this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated);
          missingAmounts.push(this.generateMissingAmount(missingAmount, WineRangeAccessibilityEnum.PREMIUM));
        }
        if (this.wine.rangeAccessibility === WineRangeAccessibilityEnum.PREMIUM) {
          return missingAmounts;
        }
        if (this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.premiumSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated <= listWineRangeAccessibility.find(function (x) {
          return x.id == WineRangeAccessibilityEnum.PREMIUM;
        }).maxAmount) {
          this.amount = this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.premiumSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated;
          this.maxValue = listWineRangeAccessibility.find(function (x) {
            return x.id == WineRangeAccessibilityEnum.ULTRA_PREMIUM;
          }).minAmount;
          missingAmount = listWineRangeAccessibility.find(function (x) {
            return x.id == WineRangeAccessibilityEnum.ULTRA_PREMIUM;
          }).minAmount - (this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.premiumSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated);
          missingAmounts.push(this.generateMissingAmount(missingAmount, WineRangeAccessibilityEnum.ULTRA_PREMIUM));
        }
        if (this.wine.rangeAccessibility === WineRangeAccessibilityEnum.ULTRA_PREMIUM) {
          return missingAmounts;
        }
        if (this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.premiumSpendingAmountNotValidated + this.categoryUser.ultraPremiumSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated <= listWineRangeAccessibility.find(function (x) {
          return x.id == WineRangeAccessibilityEnum.ULTRA_PREMIUM;
        }).maxAmount) {
          this.amount = this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.premiumSpendingAmountNotValidated + this.categoryUser.ultraPremiumSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated;
          this.maxValue = listWineRangeAccessibility.find(function (x) {
            return x.id == WineRangeAccessibilityEnum.FINE_AND_RARE;
          }).minAmount;
          missingAmount = listWineRangeAccessibility.find(function (x) {
            return x.id == WineRangeAccessibilityEnum.FINE_AND_RARE;
          }).minAmount - (this.categoryUser.coreItemSpendingAmountNotValidated + this.categoryUser.premiumSpendingAmountNotValidated + this.categoryUser.ultraPremiumSpendingAmountNotValidated + this.categoryUser.totalSpendingAmountOnValidated);
          missingAmounts.push(this.generateMissingAmount(missingAmount, WineRangeAccessibilityEnum.FINE_AND_RARE));
        }
        if (this.wine.rangeAccessibility === WineRangeAccessibilityEnum.FINE_AND_RARE) {
          return missingAmounts;
        }
      }
      return missingAmounts;
    },
    generateMissingAmount: function generateMissingAmount(missingAmount, wineRangeAccessibility) {
      var missingPoint = Math.ceil(missingAmount / 100);
      return "".concat(missingPoint, " point").concat(missingPoint > 1 ? "s" : "", " are missing to reach the \"").concat(listWineRangeAccessibility.find(function (x) {
        return x.id == wineRangeAccessibility;
      }).textForUsers, "\" level");
    },
    openToS: function openToS() {
      var anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var routeData = this.$router.resolve({
        name: "userTermsOfSales",
        hash: anchor
      });
      window.open(routeData.href);
    },
    getSymbolCurrency: function getSymbolCurrency() {
      return this.currency ? _getSymbolCurrency(this.currency) : "";
    }
  }
};